
<nav>
  <div class="mega-menu-container" [ngStyle]="{ 'display': (showMenu) ? 'inherit': 'none' }">
    <div class="mega-menu">
      <button class="mega-menu-mobile float-right" aria-haspopup="true" attr.aria-expanded="{{megaMenuBlock}}" (click)="megaMenuBlock = !megaMenuBlock">
        <span class="show-for-sr">Show Mobile Navigation Menu</span>
        <svg-icon icon="icon-bars" aria-hidden="true" class="small"></svg-icon>
      </button>
      <ul role="menubar" aria-label="Main Site Navigation Categories" [ngClass]="{ 'show-on-mobile': megaMenuBlock }" (mouseleave)="hideMenu()">
        @for (nav of data; track nav; let i = $index) {
          <li role="presentation" (mouseover)="toggleItemVisible(nav, true)">
            <button (keydown)="menubarNavKeyDown($event, nav, !nav.show, i)" setFocus="primaryLink{{i}}" (blur)="navBlur($event)" role="menuitem" class="mega-menu-option mega-menu-dropdown-icon" aria-haspopup="true" attr.aria-expanded="{{nav.expanded}}" [ngClass]="{ 'hover': nav.show == true }" (click)="toggleItemVisible(nav, !nav.show)">
              {{nav.title}}
            </button>
            <ul role="menu" class="mega-menu-block" (mouseover)="toggleItemVisible(nav, true)" tabindex="-1">
              @for (col of nav.columns; track col; let j = $index) {
                <li role="presentation">
                  <span class="nav-heading">
                    <a role="menuitem" (keydown)="menuHeadingNavKeyDown($event, j, i)" setFocus="secondaryLink{{i}}{{j}}0" tabindex="-1" class="bold" [routerLink]="['/dashboard/view/', col.uriComponent || undefined]" (click)="toggleItemVisible(nav, false)"><span>{{col.title}}</span></a>
                  </span>
                  <ul role="menu">
                    @for (item of col.items; track item; let l = $index) {
                      <li role="presentation" (click)="toggleItemVisible(nav, false)">
                        @if (item.type == itemType.ExternalLink) {
                          <a role="menuitem" setFocus="secondaryLink{{i}}{{j}}{{l+1}}" (keydown)="menuitemNavKeyDown($event, 'secondaryLink' + i + j + (l+1))" tabindex="-1"
                            [href]="item.route" target="_new">
                            {{item.title}}
                          </a>
                        } @else {
                          <a role="menuitem" setFocus="secondaryLink{{i}}{{j}}{{l+1}}" (keydown)="menuitemNavKeyDown($event, 'secondaryLink' + i + j + (l+1))" tabindex="-1" [routerLink]="item.uriComponent ? item.route + '/' + item.uriComponent : item.route">
                            {{item.title}}
                          </a>
                        }
                      </li>
                    }
                  </ul>
                </li>
              }
            </ul>
          </li>
        }
        <li role="presentation" [ngClass]="{'hide':!showMoreButton}" (mouseleave)="moreMouseEvent($event)" (mouseover)="moreMouseEvent($event)">
          <button aria-haspopup="true" (keydown)="moreKeyDown($event)" setFocus="moreLink" attr.aria-expanded="{{showMoreMenu}}" (click)="showMoreMenu=!showMoreMenu" class="more-link invisible">More...</button>
        </li>
      </ul>
      <ul role="menu" class="more-menu" [ngClass]="{'hide':!showMoreMenu}" (mouseover)="showMoreMenu=true" (mouseleave)="showMoreMenu=false">
        @for (nav of data; track nav; let index = $index) {
          <li role="presentation" (mouseover)="toggleItemVisible(nav, true)">
            <button role="menuitem" type="button" (focus)="moreMenuItemFocus(nav, index)" (keydown)="moreMenuitemKeyDown($event, index)" class="mega-menu-option" tabindex="-1" setFocus="primaryLinkMore{{index}}" [ngClass]="{ 'hover': nav.show == true }">
              {{nav.title}}
            </button>
          </li>
        }
      </ul>
    </div>
  </div>
</nav>
